import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-top-gradient',
  standalone: true,
  imports: [],
  templateUrl: './top-gradient.component.html',
  styleUrls: ['./top-gradient.component.scss'],
})
export class TopGradientComponent {
  @Input() gradient: string;
}
